module.exports = __webpack_public_path__ + "static/media/fd4.11f83ac0.jpg";